import React from 'react';
import LeadForm from './LeadForm';

function App() {
  return (
    <>
    <LeadForm />
    </>
  );
}

export default App;
